import React from 'react';
import { ButtonProps } from 'react-toolbox/lib/button/Button';
import less from './button.less';

export interface ButtonPropsExtra extends ButtonProps {
   extraClassNames?: string[];
   onExtraFunction?: () => any;
}

// tslint:disable-next-line:max-classes-per-file
export class Btn extends React.Component<ButtonProps, ButtonPropsExtra, any> { 
  className = this.props.className;
  type = this.props.type;
  role = this.props.role;
  disabled = this.props.disabled;
  extraClassNames= this.props.extraClassNames ? this.props.extraClassNames:[];
  arialabel = this.props['aria-label'];  
  ariahaspopup = this.props['has-popup'];                       
  tabIndex = this.props.tabIndex;  
  allClassNames: string[] = [];

  public render() { 
    this.allClassNames= [this.className];
    if (this.extraClassNames) 
      this.allClassNames=this.allClassNames.concat(this.extraClassNames);
    
    if (this.props.disabled) this.allClassNames = this.allClassNames.concat('disabled');
    
    let button = <button
        type={this.type}
        role={this.role}
        disabled={this.props.disabled}
        tabIndex={this.tabIndex}
        aria-label={this.arialabel}
        aria-haspopup={this.ariahaspopup}             
        className={less(this.allClassNames)}
        onClick={() => this.props.onClick()}
      >              
        {this.props.children}
      </button>;
    
    // (button as HTMLButtonElement).disabled=false;
    return (button);
  }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/react-toolbox-redesign/button.tsx